import { TRANSLATION_CONFIG } from 'src/_shared/config/language';
export async function getBundledTranslation(langCode, collectionId) {
    const { LANGUAGE } = TRANSLATION_CONFIG;
    const mappedLangCode = LANGUAGE[langCode] || LANGUAGE.default;
    return await import(`./translation${mappedLangCode}${collectionId ? `.col${collectionId}` : ''}.json`);
}
